import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { toast } from "sonner";

const Register = () => {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Welcome to Amazypet!");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("auth.registerError"));
    } finally {
      setSubmitting(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="register-page" className="max-w-[440px] mx-auto px-6 py-20">
      <p className="overline mb-3 text-center">Amazypet</p>
      <h1 className="font-serif text-4xl text-center mb-10">{t("auth.registerTitle")}</h1>

      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="overline mb-1 block">{t("auth.name")}</label>
          <input required className="luxury-input-box" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        </div>
        <div>
          <label className="overline mb-1 block">{t("auth.email")}</label>
          <input type="email" required className="luxury-input-box" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        </div>
        <div>
          <label className="overline mb-1 block">{t("auth.password")}</label>
          <input type="password" required minLength={6} className="luxury-input-box" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        </div>
        <button type="submit" disabled={submitting} className="luxury-btn w-full" data-testid="register-submit">
          {submitting ? "..." : t("auth.submitRegister")}
        </button>
      </form>

      <div className="flex items-center my-8 gap-4 text-xs text-[#736B66] uppercase tracking-widest">
        <div className="h-px bg-[#EBE5DF] flex-1" />
        {t("auth.orWith")}
        <div className="h-px bg-[#EBE5DF] flex-1" />
      </div>

      <button onClick={googleLogin} className="luxury-btn-outline w-full" data-testid="google-register">
        {t("auth.googleLogin")}
      </button>

      <p className="text-center text-sm text-[#736B66] mt-8">
        {t("auth.hasAccount")} <Link to="/login" className="text-[#2C1E16] underline">{t("auth.signIn")}</Link>
      </p>
    </div>
  );
};

export default Register;
